import ShopCreation from "components/pages/ShopCreation"

export default function ShopCreatorPage() {
  return <ShopCreation />
}
